import React from 'react';
import styled from '@emotion/styled';

import { useAlgoliaProductViewedEvent, useLocale } from '~/components';
import { baseArticlesIndexName, getAnalyticIndexName } from '~/src/common/media-hero';
import { AboutTeacher } from '~/src/components/content-page-components';
import { ArticlePaywall } from '~/src/components/modals/paywalls/ArticlePaywall';

import type { Content } from '../types';

import { Details } from './Details';
import { PromoteBookSnackbar } from './PromoteBookSnackbar';
import { StartFreeTrialCTA } from './StartFreeTrialCTA';
import { useActivePromoKey } from './useActivePromoKey';

const AboutTeacherContainer = styled.div`
  background: white;
`;

const Container = styled.div`
  background: white;
`;

interface Props {
  content: Content;
}

export const ArticlePageContent: React.FC<Props> = ({ content }) => {
  const { locale } = useLocale();

  const { id } = content;

  const indexName = getAnalyticIndexName(baseArticlesIndexName, locale);
  useAlgoliaProductViewedEvent({ contentID: id, indexName });

  const { activePromoKey } = useActivePromoKey(content);

  return (
    <Container>
      <Details content={content} />
      <StartFreeTrialCTA />
      <AboutTeacherContainer>
        <AboutTeacher content={content} />
      </AboutTeacherContainer>
      {activePromoKey === 'promote-book' && <PromoteBookSnackbar />}
      {activePromoKey === 'paywall' && <ArticlePaywall />}
    </Container>
  );
};
